/*******************************************************************************
TRIGGER TAB SWITCH
Handles a click on a tab.
*******************************************************************************/

// https://www.npmjs.com/package/idb-keyval
import { Store, set } from '../../../lib/_idb-keyval/idb-keyval';

import switchTab from './switch-tab';

export default function triggerTabSwitch(e) {

    // Get the name of the tab that was clicked on and switch to it
    const $tab = $(e.currentTarget);
    const tabName = $tab.data('name');
    const tabSetName = $tab.parents('.toggle-tabs').data('name');

    // Save the selected tab to the browser's indexDB storage
    const rwStore = new Store('rotowire', 'toggletabs');
    set(tabSetName, tabName, rwStore).catch((err) => {
        console.log(`IDB KeyVal Error: ${err}`); // eslint-disable-line
    });

    switchTab(tabSetName, tabName);
}
